<app-loader *ngIf="isLoading"></app-loader>
<div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
    <div>
        <h4 class="q-heading">
            <span><img src="../../../assets/images/backarrow.png" (click)="goBack()" alt=""
                    class="me-2 cursor-pointer" /></span>
            {{ "MANAGEDEVICE.UPDATEVIRUSDB" | translate }}
        </h4>
    </div>

    <div class="ms-auto">
        <form [formGroup]="restorePublishForm">
            <select class="form-select bg-transparent" formControlName="mobileDeviceName"
                (change)="onMobileDeviceSelect($event)">
                <option *ngFor="let item of mobileDevice" [value]="item.id">
                    {{ item.deviceName }}
                </option>
            </select>
        </form>
        <!-- <select class="form-select bg-transparent" [(ngModel)]="deviceId"
                        (change)="onMobileDeviceSelect($event)">
                        <option *ngFor="let item of mobileDevice" [value]="item.id">
                            {{ item.name }}
                        </option>
                    </select> -->
    </div>
</div>



<div class="commandsBG-WHITE mb-5 mb-md-0 text-center">
    <div class="row">
        <div class="col-md-12 mb-3">
            <img src="./assets/images/UPDATEVIRUSDB.png" alt="" class="w-200">
        </div>
        <p class="mb-3">{{ "MANAGEDEVICE.UPDATEVIRUSTEXT" | translate }}</p>
    </div>

    <div class="row mb-0 mb-md-5">
        <div class="col-md-12">
            <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto" (click)="sendCommand()">
                {{ "MANAGEDEVICE.UPDATE" | translate }}
            </button>
            <!-- <button *ngIf="lockData" type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto"
            (click)="openLockModal()">
            {{ "MANAGEDEVICE.UNLOCK" | translate }}
        </button> -->
        </div>

        <div class="col-md-12 text-center mt-2">
            <app-last-updated-on [deviceId]="deviceId" [requestType]="UPDATE_VIRUS_DB"></app-last-updated-on>
        </div>
    </div>
</div>


<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="LockPopup"
    data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
    aria-hidden="true">
    <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
        <div
            class="modal-content border-none p-4 shadow-lg relative pointer-events-auto rounded-25 bg-white outline-none">
            <!-- <ng-container *ngIf="!isLock">
                <div class="mt-4">
                    <img src="./assets/images/updatevirus.png" alt="" class="mx-auto" height="100px" />
                </div>
                <p class="lightgray-clr text-sm">{{ "MANAGEDEVICE.UPDATE" | translate }} {{deviceName}}</p>
                <ng-container *ngIf="errorMessage">
                    <p class="errMessage" style="margin: 10px 90px">{{ errorMessage }}</p>
                </ng-container>
                <div class="text-center mb-4 d-flex justify-content-center">
                    <div class="me-3">
                        <button type="button" class="submit-btn bg-orgclr" (click)="sendCommand()">
                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                        </button>
                    </div>
                    <div class="">
                        <button type="button" class="cancel-btn bg-cancelbtn" data-bs-dismiss="modal"
                            (click)="closeModal()">
                            {{ "LOGIN.CANCEL" | translate }}
                        </button>
                    </div>
                </div>
            </ng-container> -->
            <ng-container *ngIf="isLock">
                <div class="mt-4">
                    <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
                </div>
                <h5 class="fw-bold mt-4 deleteUser">
                    {{"SUCESSMESSAGE.UPDATEVIRUSSUCCESSFULLY" | translate}}
                </h5>
           
            </ng-container>
        </div>
    </div>
</div>